<template>
<div>
    <div :style="{ fontSize: fontSize + 'px' }">{{ units }}, {{ cents }}</div>
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: 0
        },
        fontSize: {
            type: String,
            default: "12"
        },
        decimals: {
            type: Number,
            default: 2
        }
    },
    computed: {
        units() {
            if(this.value === 0) {
                return
            }
            return this.value.toString()
                .split('.')[0];
        },
        cents() {
            if(this.value === 0) {
                return
            }

            let cents = this.value.toString()
                .split('.')[1];
            if(cents) {
                let rounding = cents.substring(0, this.decimals);
                if(rounding.length > 1) {
                    return rounding;
                } else {
                    return rounding + '0';
                }
            } else {
                return '00';
            }
        }
    }
}
</script>

<style>
.currency {
    font-weight: 300;
}
</style>
